import { render, staticRenderFns } from "./cooperation_list_add.vue?vue&type=template&id=9c40a40e&scoped=true&"
import script from "./cooperation_list_add.vue?vue&type=script&lang=js&"
export * from "./cooperation_list_add.vue?vue&type=script&lang=js&"
import style0 from "./cooperation_list_add.vue?vue&type=style&index=0&id=9c40a40e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c40a40e",
  null
  
)

export default component.exports